import React, { useState } from "react"
import { Bus, Car } from "lucide-react"

const looksLikeBus = (name = "") => /bus|автобус|van|вэн|мини/i.test(name)

const TransportTypeIcon = ({ icon, name, className = "w-9 h-9" }) => {
  const [failed, setFailed] = useState(false)

  if (icon && !failed) {
    return (
      <img
        src={icon}
        alt={name}
        onError={() => setFailed(true)}
        className={`${className} object-contain`}
      />
    )
  }

  const Fallback = looksLikeBus(name) ? Bus : Car
  return <Fallback className={`${className} text-app-base-strong/50`} strokeWidth={1.5} />
}

export default TransportTypeIcon
